import React, { useState } from 'react';
import styled from 'styled-components';
import theme from '../../theme';
import Fade from 'react-reveal/Fade';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { ReactComponent as CloseIcon } from "../../images/close.svg";
const renderHTML = rawHTML => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

const TeamItem = ({ itemId, image, name, title, text, boxOpened, handleTeamClick }) => {
  const [boxOpenedZIndex, setBoxOpenedZIndex] = useState(false);
  const [isMobile, setIsMobile] = useState(true);

  React.useEffect(() => {
    if (window.innerWidth > 992) {
      setIsMobile(false);
    }
  }, []);


  if (boxOpened && !boxOpenedZIndex) {
    setBoxOpenedZIndex(true);
  } else if (!boxOpened && boxOpenedZIndex) {
    console.log(window.innerWidth)
    if (window.innerWidth > 991) {
      setTimeout(() => setBoxOpenedZIndex(false), 300);
    } else {
      setBoxOpenedZIndex(false)
    }
  }

  return (
    <Wrapper boxOpenedZIndex={boxOpenedZIndex}>
      <Fade>
        <>
          <InnerBox onClick={() => handleTeamClick(itemId)}>
            {Boolean(image) && <img src={image} alt={name} />}
            <Heading>{name}</Heading>
            <Description>{title}</Description>
          </InnerBox>
          <TransitionGroup component={null}>
            {boxOpened &&
              <CSSTransition key={itemId} classNames="fade" timeout={isMobile ? 0 : 1000}>
                <OverflowBox>
                  <>
                    <CloseIconStyled onClick={() => handleTeamClick(itemId)}>
                      <CloseIcon />
                    </CloseIconStyled>
                    {renderHTML(text)}
                  </>
                </OverflowBox>
              </CSSTransition>
            }
          </TransitionGroup>

        </>
      </Fade>
    </Wrapper>
  )
}

const CloseIconStyled = styled.div`
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;

  @media(min-width: 992px) {
    position: absolute;
    right: 50px;
    top: 35px;
  }
`

const boxOffset = 90;

const OverflowBox = styled.section`
  background: white;
  box-shadow: 0 0 35px rgba(0, 0, 0, .05);
  
  width: 100%;
  z-index: 3;
  padding: 15px;
  position: relative;

  @media(min-width: 992px) {
    position: absolute;
    padding: ${boxOffset}px 50px 30px ${320 + boxOffset}px;
    width: calc(100% + 750px);
    height: calc(100% + ${boxOffset * 2}px);
    left: -${boxOffset}px;
    top: -${boxOffset}px;
    min-height: 410px;
  }

  p {
    font-size: 18px;
  }
`

const InnerBox = styled.div`
  position: relative;
  z-index: 5;
  cursor: pointer;
  text-align: center;
`

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  margin-bottom: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: ${props => props.boxOpenedZIndex ? '10' : '5'};

  @media(min-width: 992px) {
    width: 33%;
  }

  .react-reveal {
    position: relative;
  }
`;

const Heading = styled.h3`
  margin-top: 20px;
  font-size: 23px;
  color: ${theme.colors.primary}
`

const Description = styled.p`
  color: ${theme.colors.text.primary}
`

export default TeamItem;